import { useEffect } from 'react'

import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline'
import { useQueryClient } from '@tanstack/react-query'

import Breadcrumb from '@/components/navigation/Breadcrumb'
import { CURRENCY_PAYMENTS_QUERY_KEY } from '@/hooks/currencyPayments/useCurrencyPaymentsQuery'

// import { FiltersRow } from './filters/FiltersRow'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'
import { FiltersRow } from './FiltersRow'

export default function CurrencyPaymentsList() {
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [CURRENCY_PAYMENTS_QUERY_KEY],
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Breadcrumb
        icon={<ClipboardDocumentListIcon className="h-6 text-gray-500" />}
        paths={[
          { name: 'Registros' },
          { name: 'Pagos recibidos' },
          { name: 'Todos' },
        ]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable />
      </TableContextProvider>
    </div>
  )
}
